<div class="notification-bar">
    <span class="icon-wrap inline">
        <i class='bx bxs-info-circle'></i>
    </span>

    <ng-content></ng-content>

</div>
